export default class CountryService {

	public static getSelectorList($axios) {
		return $axios.get(`/v1/country/filter`);
	}

	public static getSelectorListCountry($axios) {
		return $axios.get(`/travel/filter-country`);
	}
	public static getSelectorListPackageCountry($axios) {
		return $axios.get(`/public-travel_pack/filter-country`);
	}

}
